import LayoutV2 from "containers/LayoutV2";
import { useState, useEffect } from "react";
import DateTimePicker from "components/GenericComponent/DateTimePicker";
import { formatDayMonth } from "utils/formatDate";
import configs from "constants/configs";
import userApi from "service/userApi";
import { pushNotification } from "utils/notifications";
import { convertDate } from "utils/formatDate";

const ThongTinDangNhap = () => {
  const [loading, setLoading] = useState(false);

  const [TabActive, setTabActive] = useState("tab1");
  const [UserName, setUserName] = useState("");
  const [Role, setRole] = useState("shopadmin");
  const [FirstName, setFirstName] = useState("");
  const [Sex, setSex] = useState(1);
  const [BirthDay, setBirthday] = useState(new Date());
  const [Address, setAddress] = useState("");
  const [Phone, setPhone] = useState("");
  const [Email, setEmail] = useState("");
  const [Image, setImage] = useState("/app-assets/images/no_image.png");
  const [AccountName, setAccountName] = useState("");
  const [Code, setCode] = useState("");

  const [saving, setSaving] = useState(false);
  const [errors, setErrors] = useState({});

  const [OldPassword, setOldPassWord] = useState("");
  const [NewPassword1, setNewPassWord1] = useState("");
  const [NewPassword2, setNewPassWord2] = useState("");

  useEffect(() => {
    const hash = window.location.hash.replace("#", "");
    if (hash) {
      setTabActive(hash);
    }
    document.title = "Thông tin tài khoản | Phần mềm quản lý cầm đồ - Morman";
    loadData();
  }, []);

  const loadData = async () => {
    try {
      setLoading(true);
      const res = await userApi.getAllUserInfor();
      if (res.data) {
        console.log("data: ", res.data);
        setRole(res.data.Role);
        setFirstName(res.data.enUser.FirstName);
        setBirthday(convertDate(res.data.enUser.BirthDay));
        setUserName(res.data.enUser.UserName);
        setAddress(res.data.enUser.Address);
        setPhone(res.data.enUser.Phone);
        setEmail(res.data.enUser.Email);
        if (res.data.enUser.Image) {
          const fullImagePath = res.data.enUser.Image.startsWith("http")
            ? res.data.enUser.Image
            : configs.apiViewUpload + res.data.enUser.Image;
          setImage(fullImagePath);
        } else {
          setImage(configs.apiViewUpload + "Image/icon-avatar-default.png");
        }
        setAccountName(res.data.enUser.FirstName);
        setCode(res.data.code);
      } else {
        pushNotification(
          "Không tìm thấy dữ liệu người dùng",
          "error",
          "TOP_CENTER",
          1000,
        );
      }
    } catch {
      pushNotification(
        "Có lỗi xảy ra khi gọi api và xử lý dữ liệu. Vui lòng thử lại.",
        "error",
        "TOP_CENTER",
        1000,
      );
    } finally {
      setLoading(false);
    }
  };
  const validateInfor = () => {
    let newErrors = {};
    if (!FirstName.trim()) newErrors.FirstName = "Nhập tên";
    if (!Phone.trim()) newErrors.Phone = "Nhập số điện thoại";
    if (BirthDay === null) newErrors.BirthDay = "Nhập ngày";
    if (Email) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(Email)) {
        newErrors.Email = "Email không hợp lệ (vd: example@gmail.com)";
      }
    }
    return newErrors;
  };
  const validatePass = () => {
    let newErrors = {};
    if (!OldPassword.trim()) newErrors.OldPassword = "Nhập mật khẩu cũ";
    if (!NewPassword1.trim()) newErrors.NewPassword1 = "Nhập mật khẩu mới";
    if (!NewPassword2.trim()) newErrors.NewPassword2 = "Nhập lại mật khẩu mới";
    if (NewPassword1.trim()) {
      const hasLetter = /[A-Za-z]/.test(NewPassword1);
      const hasNumber = /\d/.test(NewPassword1);
      if (!hasLetter || !hasNumber) {
        newErrors.NewPassword1 = "Mật khẩu phải bao gồm cả chữ và số";
      }
      if (NewPassword1.length < 6) {
        newErrors.NewPassword1 = "Mật khẩu mới phải có ít nhất 6 ký tự.";
      }
    }
    if (NewPassword2.trim()) {
      if (NewPassword2 != NewPassword1) {
        newErrors.NewPassword2 = "Mật khẩu mới không khớp";
      }
    }
    return newErrors;
  };

  const handleSavePass = async () => {
    const newErrors = validatePass();
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }
    setSaving(true);
    try {
      setErrors({});
      const payload = {
        UserName,
        OldPassword,
        NewPassword: NewPassword2,
      };
      const res = await userApi.UserChangePass(payload);
      if (res.status === 200) {
        pushNotification(
          "Đổi mật khẩu thành công. Vui lòng đăng nhập lại.",
          "success",
          "TOP_CENTER",
          1500,
        );
        localStorage.removeItem("token");
        sessionStorage.clear();
        setTimeout(() => {
          window.location.href =
            window.mormanServer + "dang-nhap.aspx?Logout=1";
        }, 1500);
      } else {
        pushNotification(res.data.Message, "error", "TOP_CENTER", 1000);
      }
    } catch {
      pushNotification(
        "Lỗi khi gọi Api Đổi mật khẩu!",
        "error",
        "TOP_CENTER",
        1000,
      );
    } finally {
      setSaving(false);
    }
  };
  const handleSaveInfor = async () => {
    const newErrors = validateInfor();
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }
    setSaving(true);
    setErrors({});
    const payload = {
      UserName,
      FirstName,
      Sex,
      BirthDay: formatDayMonth(BirthDay),
      Address,
      Phone,
      Email,
      Image,
    };
    console.log("data payload: ", payload);
    try {
      const res = await userApi.UpdateUserInfor(payload);
      if (res.status === 200) {
        pushNotification("Cập nhật thành công.", "success", "TOP_CENTER", 1000);
        loadData();
      } else {
        pushNotification("Cập nhật thất bại", "error", "TOP_CENTER", 1000);
      }
    } catch {
      pushNotification(
        "Lỗi khi gọi Api Cập nhật thông tin cá nhân!",
        "error",
        "TOP_CENTER",
        1000,
      );
    } finally {
      setSaving(false);
    }
  };
  const handleChangeImage = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    try {
      // Hiển thị ảnh tạm (preview)
      const localPreview = URL.createObjectURL(file);
      setImage(localPreview);

      // Upload lên server
      const formData = new FormData();
      formData.append("File", file);

      const uploadUrl =
        configs.apiUpload +
        `api/uploadfile/UploadImage?sCode=${Code}&sDuAn=Morman`;

      const response = await fetch(uploadUrl, {
        method: "POST",
        body: formData,
      });

      const result = await response.json();

      if (result && result.FilePath) {
        // Cập nhật ảnh thật từ server
        const serverImage = result.FilePath.startsWith("http")
          ? result.FilePath
          : configs.apiViewUpload + result.FilePath;

        setImage(serverImage);
        pushNotification(
          "Tải ảnh lên thành công!",
          "success",
          "TOP_CENTER",
          1000,
        );
      } else {
        pushNotification("Không thể tải ảnh lên!", "error", "TOP_CENTER", 1000);
      }
    } catch (error) {
      console.error("Upload image error:", error);
      pushNotification(
        "Có lỗi khi tải ảnh lên server!",
        "error",
        "TOP_CENTER",
        1000,
      );
    }
  };

  return (
    <>
      <LayoutV2>
        <div id="form-repeater">
          <div className="sticky-moman-bh">
            <div className="col-12">
              <div className="camdo-home">
                <div className="breadcrumb-new">
                  <div className="row">
                    <div className="col-sm-12 col-md-12 title-cd">
                      <div className="media-home align-center-home">
                        <div className="row header">
                          <h1 className="text-info-home">Tài khoản</h1>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {loading && (
                  <>
                    <div className="loader loader-default is-active"></div>
                  </>
                )}
                {!loading && (
                  <>
                    <div
                      className="card border-light mb-3 card-v2"
                      style={{ backgroundColor: "#f4f5fa" }}
                    >
                      <div
                        className="row"
                        style={{ backgroundColor: "#F4F5FA" }}
                      >
                        <div
                          className="col-md-2"
                          style={{ paddingRight: "0px" }}
                        >
                          <div
                            style={{
                              backgroundColor: "white",
                              borderRadius: "10px",
                              height: "524px",
                              padding: "10px",
                              textAlign: "center",
                            }}
                          >
                            <div
                              style={{
                                height: "30%",
                                display: "flex",
                                alignItems: "center",
                                textAlign: "center",
                                padding: "5px",
                                marginBottom: "10px",
                                justifyContent: "center",
                              }}
                            >
                              <img
                                id="ctl00_ContentPlaceHolder_imgUser"
                                className="image-avatar"
                                alt="avatar"
                                src={Image}
                                style={{
                                  borderWidth: "0px",
                                  width: "150px",
                                  height: "150px",
                                  borderRadius: "50%",
                                  objectFit: "cover",
                                }}
                              />
                            </div>
                            <div>
                              <h1 className="color7-bold">{AccountName}</h1>
                            </div>
                            <div>
                              {Role === "shopadmin"
                                ? "Chủ"
                                : Role === "shopmanager"
                                  ? "Quản lý"
                                  : "Nhân viên"}
                            </div>
                            <div>
                              <label className="btn">
                                <img src="/app-assets/images/icon-upload-img-v2.png" />
                                <input
                                  type="file"
                                  className="hidden"
                                  name="file"
                                  accept="image/*"
                                  onChange={handleChangeImage}
                                />
                              </label>
                            </div>
                          </div>
                        </div>
                        <div
                          className="col-md-10"
                          style={{ paddingLeft: "10px" }}
                        >
                          <div id="tabs" style={{ height: "524px" }}>
                            <ul
                              className="nav tab-taikhoan"
                              role="tablist"
                              style={{
                                borderRadius: "10px",
                                height: "10%",
                                width: "fit-content",
                              }}
                            >
                              <li
                                style={{
                                  backgroundColor:
                                    TabActive === "tab1" ? "#056569 " : "white",
                                  padding: "13px",
                                  borderTopLeftRadius: "10px",
                                }}
                                onClick={(e) => {
                                  if (saving) return;
                                  setTabActive("tab1");
                                }}
                              >
                                <a
                                  className="tab-link active"
                                  href="#tab1"
                                  role="tab"
                                  style={{
                                    color:
                                      TabActive === "tab1"
                                        ? "white"
                                        : "#056569",
                                  }}
                                  aria-selected="true"
                                >
                                  <i class="fa-solid fa-user"></i>
                                  &nbsp;&nbsp; Thông tin tài khoản
                                </a>
                              </li>
                              <li
                                style={{
                                  backgroundColor:
                                    TabActive === "tab2" ? "#056569 " : "white",
                                  padding: "13px",
                                  borderTopRightRadius: "10px",
                                }}
                                onClick={(e) => {
                                  if (saving) return;
                                  setTabActive("tab2");
                                }}
                              >
                                <a
                                  className="tab-link"
                                  href="#tab2"
                                  role="tab"
                                  style={{
                                    color:
                                      TabActive === "tab2"
                                        ? "white"
                                        : "#056569 ",
                                  }}
                                  aria-selected="false"
                                >
                                  <i class="fa-solid fa-key"></i>
                                  &nbsp;&nbsp;Thay đổi mật khẩu
                                </a>
                              </li>
                            </ul>
                            <div
                              className="tab-content px-1  bg-content-tab"
                              style={{
                                borderRadius: "10px",
                                paddingTop: "7px",
                                height: "90%",
                              }}
                            >
                              {TabActive === "tab1" && (
                                <div
                                  id="tab1"
                                  style={{ height: "100%" }}
                                  className="tab-pane fade active show"
                                >
                                  <div
                                    style={{
                                      backgroundColor: "white",
                                      minHeight: "88%",
                                      borderRadius: "10px",
                                      marginBottom: "1%",
                                      padding: "10px",
                                    }}
                                  >
                                    <h3>
                                      <p className="color-xanh-bold">
                                        Thông tin đăng nhập
                                      </p>
                                    </h3>
                                    <div className="row">
                                      <div className="col-md-4">
                                        <div className="form-group">
                                          <label>
                                            <span className="text-bold color7">
                                              Email đăng nhập
                                            </span>
                                          </label>
                                          <input
                                            type="text"
                                            className="form-control"
                                            disabled
                                            value={UserName}
                                          />
                                        </div>
                                      </div>
                                      <div className="col-md-4">
                                        <div className="form-group">
                                          <label>
                                            <span className="text-bold color7">
                                              Mật khẩu
                                            </span>
                                          </label>
                                          <input
                                            type="password"
                                            className="form-control"
                                            disabled
                                            placeholder="**********"
                                          />
                                        </div>
                                      </div>
                                      <div className="col-md-4">
                                        <div className="form-group">
                                          <label>
                                            <span className="text-bold color7">
                                              Quyền
                                            </span>
                                          </label>
                                          <select
                                            className="form-control"
                                            value={Role}
                                            disabled
                                          >
                                            <option value="shopadmin">
                                              Chủ
                                            </option>
                                            <option value="shopmanager">
                                              Quản lý
                                            </option>
                                            <option value="shopuser">
                                              Nhân viên
                                            </option>
                                          </select>
                                        </div>
                                      </div>
                                    </div>
                                    <h3>
                                      <p className="color-xanh-bold">
                                        Thông tin cá nhân
                                      </p>
                                    </h3>
                                    <div className="row">
                                      <div className="col-md-4">
                                        <div className="form-group">
                                          <label>
                                            <span className="text-bold color7">
                                              Họ tên{" "}
                                            </span>
                                            <span className="red">(*)</span>
                                          </label>
                                          <input
                                            type="text"
                                            className="form-control"
                                            value={FirstName}
                                            onChange={(e) =>
                                              setFirstName(e.target.value)
                                            }
                                          />
                                          {errors.FirstName && (
                                            <div className="text-danger">
                                              {errors.FirstName}
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                      <div className="col-md-4">
                                        <div className="form-group">
                                          <label>
                                            <span className="text-bold color7">
                                              Giới tính
                                            </span>
                                          </label>
                                          <select
                                            className="form-control"
                                            value={Sex}
                                            onChange={(e) =>
                                              setSex(e.target.value)
                                            }
                                          >
                                            <option value="1">Nam</option>
                                            <option value="2">Nữ</option>
                                          </select>
                                        </div>
                                      </div>
                                      <div className="col-md-4">
                                        <div className="form-group">
                                          <label>
                                            <span className="text-bold color7">
                                              Ngày sinh
                                            </span>
                                          </label>
                                          <DateTimePicker
                                            value={BirthDay}
                                            onChange={(e) => setBirthday(e)}
                                            placeholder="Chọn ngày sinh"
                                          />
                                          {errors.BirthDay && (
                                            <div className="text-danger">
                                              {errors.BirthDay}
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                      <div className="col-md-4">
                                        <div className="form-group">
                                          <label>
                                            <span className="text-bold color7">
                                              Địa chỉ
                                            </span>
                                          </label>
                                          <input
                                            type="text"
                                            className="form-control"
                                            value={Address}
                                            onChange={(e) =>
                                              setAddress(e.target.value)
                                            }
                                          />
                                        </div>
                                      </div>
                                      <div className="col-md-4">
                                        <div className="form-group">
                                          <label>
                                            <span className="text-bold color7">
                                              Số điện thoại
                                            </span>{" "}
                                            <span className="red">(*)</span>
                                          </label>
                                          <input
                                            type="text"
                                            className="form-control"
                                            value={Phone}
                                            onChange={(e) =>
                                              setPhone(e.target.value)
                                            }
                                          />
                                          {errors.Phone && (
                                            <div className="text-danger">
                                              {errors.Phone}
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                      <div className="col-md-4">
                                        <div className="form-group">
                                          <label>
                                            <span className="text-bold color7">
                                              Email
                                            </span>
                                          </label>
                                          <input
                                            type="text"
                                            className="form-control"
                                            value={Email}
                                            onChange={(e) =>
                                              setEmail(e.target.value)
                                            }
                                          />
                                          {errors.Email && (
                                            <div className="text-danger">
                                              {errors.Email}
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    style={{
                                      borderRadius: "10px",
                                      backgroundColor: "white",
                                      height: "10%",
                                      padding: "5px",
                                      display: "flex",
                                      justifyContent: "flex-end",
                                      flexDirection: "row",
                                    }}
                                  >
                                    <button
                                      className="btn"
                                      onClick={handleSaveInfor}
                                      disabled={saving}
                                      style={{
                                        background: "#056569",
                                        color: "white",
                                        borderRadius: "6px",
                                        fontSize: "15px",
                                        textTransform: "none",
                                        height: "100%",
                                        textAlign: "center",
                                      }}
                                    >
                                      {saving ? (
                                        <>
                                          <span className="spinner-border spinner-border-sm"></span>
                                          &nbsp; Đang lưu...
                                        </>
                                      ) : (
                                        <>
                                          <p>
                                            <i class="fas fa-save"></i> Lưu
                                            thông tin
                                          </p>
                                        </>
                                      )}
                                    </button>
                                  </div>
                                </div>
                              )}
                              {TabActive === "tab2" && (
                                <div
                                  id="tab2"
                                  style={{ height: "100%" }}
                                  className="tab-pane fade active show"
                                >
                                  <div
                                    style={{
                                      backgroundColor: "white",
                                      minHeight: "88%",
                                      borderRadius: "10px",
                                      marginBottom: "1%",
                                    }}
                                  >
                                    <h3
                                      style={{
                                        fontSize: "18px",
                                        color: "#00B69B",
                                        paddingLeft: "10px",
                                        paddingTop: "10px",
                                      }}
                                    >
                                      <b>Mật khẩu đăng nhập</b>
                                    </h3>
                                    <div
                                      className="row"
                                      style={{
                                        paddingLeft: "10px",
                                        paddingTop: "10px",
                                      }}
                                    >
                                      <div className="col-md-4">
                                        <div className="form-group">
                                          <label>
                                            <span className="text-bold color7">
                                              {" "}
                                              Mật khẩu cũ{" "}
                                            </span>
                                            <span className="red">(*)</span>
                                          </label>
                                          <input
                                            type="password"
                                            className="form-control"
                                            value={OldPassword}
                                            onChange={(e) =>
                                              setOldPassWord(e.target.value)
                                            }
                                          />
                                          {errors.OldPassword && (
                                            <div className="text-danger">
                                              {errors.OldPassword}
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                      <div className="col-md-4">
                                        <div className="form-group">
                                          <label>
                                            <span className="text-bold color7">
                                              Mật khẩu mới{" "}
                                            </span>
                                            <span className="red">(*)</span>
                                          </label>
                                          <input
                                            type="password"
                                            className="form-control"
                                            value={NewPassword1}
                                            onChange={(e) =>
                                              setNewPassWord1(e.target.value)
                                            }
                                          />
                                          {errors.NewPassword1 && (
                                            <div className="text-danger">
                                              {errors.NewPassword1}
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                      <div className="col-md-4">
                                        <div className="form-group">
                                          <label>
                                            <span className="text-bold color7">
                                              Xác nhận mật khẩu{" "}
                                            </span>
                                            <span className="red">(*)</span>
                                          </label>
                                          <input
                                            type="password"
                                            className="form-control"
                                            value={NewPassword2}
                                            onChange={(e) =>
                                              setNewPassWord2(e.target.value)
                                            }
                                          />
                                          {errors.NewPassword2 && (
                                            <div className="text-danger">
                                              {errors.NewPassword2}
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    style={{
                                      borderRadius: "10px",
                                      backgroundColor: "white",
                                      height: "10%",
                                      padding: "5px",
                                      display: "flex",
                                      justifyContent: "flex-end",
                                      flexDirection: "row",
                                    }}
                                  >
                                    <button
                                      className="btn"
                                      onClick={handleSavePass}
                                      disabled={saving}
                                      style={{
                                        background: "#056569",
                                        color: "white",
                                        borderRadius: "6px",
                                        fontSize: "15px",
                                        textTransform: "none",
                                        height: "100%",
                                        textAlign: "center",
                                      }}
                                    >
                                      {saving ? (
                                        <>
                                          <span className="spinner-border spinner-border-sm"></span>
                                          &nbsp; Đang lưu...
                                        </>
                                      ) : (
                                        <>
                                          <p>
                                            <i class="fas fa-save"></i> Lưu
                                            thông tin
                                          </p>
                                        </>
                                      )}
                                    </button>
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </LayoutV2>
    </>
  );
};

export default ThongTinDangNhap;
